import React, { useState } from "react";

import img1 from "../../assets/images/layouts/about-01.png";
import img2 from "../../assets/images/layouts/about-02.png";
import img3 from "../../assets/images/layouts/about-03.png";
import img4 from "../../assets/images/layouts/about-04.png";
import img5 from "../../assets/images/layouts/about-05.png";
import Button from "../button/Button";
import { motion } from "framer-motion";

function About(props) {
  const [dataImg] = useState([
    {
      id: 1,
      img: "https://4kwallpapers.com/images/walls/thumbs_3t/19041.jpg",
      class: "img1",
    },
    {
      id: 2,
      img: "https://4kwallpapers.com/images/walls/thumbs_3t/18443.jpg",
      class: "img2",
    },
    {
      id: 3,
      img: "https://4kwallpapers.com/images/walls/thumbs_3t/17634.jpg",
      class: "img3",
    },
    {
      id: 4,
      img: "https://4kwallpapers.com/images/walls/thumbs_3t/8280.jpg",
      class: "img4",
    },
    {
      id: 5,
      img: "https://4kwallpapers.com/images/walls/thumbs_3t/17806.jpg",
      class: "img5",
    },
  ]);

  const [dataBlock] = useState({
    subheading: "About us",
    heading: "Secure Gaming, Rewarding Prizes",
    desc1:
      "PlayersPortal values security, ensuring safe and fair experiences for all. With time, skill, and dedication, participants earn exciting prizes, fostering trust and rewarding persistence.",
    desc2:
      "PlayerzPortal ensures match security by verifying room details and monitoring for unauthorized players. Only registered participants access matches, safeguarding fairness. Winners are verified and awarded prizes swiftly, guaranteeing transparency and trust in every competition.",
  });
  return (
    <section className="about">
      <div className="shape"></div>
      <div className="container">
        <div className="grid md:grid-cols-2 ">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            whileInView="visible"
            viewport={{ once: true }}
            className="col-xl-6 col-md-12"
          >
            <div className="about__right">
              <div className="images">
                {dataImg.map((idx) => (
                  <img
                    key={idx.id}
                    className={idx.class}
                    src={idx.img}
                    alt="cyfonii"
                  />
                ))}
              </div>
            </div>
          </motion.div>
          <div className="col-xl-6 col-md-12">
            <div className="block-text">
              <h6 className="sub-heading">
                <span>{dataBlock.subheading}</span>
              </h6>
              <h3 className="heading">{dataBlock.heading}</h3>
              <p className="mb-17">{dataBlock.desc1}</p>
              <p className="mb-26">{dataBlock.desc2}</p>
              <Button link="/about" title="More About Us" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
